export type ImpactPeriod = 'month' | 'year';
